import { Trans } from '@lingui/react'

import {
  EMAIL_FIELD,
  ERROR_AUTH_SERVICE,
  ERROR_BADINPUT,
  ERROR_UNAVAILABLE,
  FIRSTNAME_FIELD,
  GENERAL_ERROR,
  LASTNAME_FIELD,
  PASSWORD_FIELD,
} from 'shared/consts'

export const ERR_DOB_INVALID = 'customers.dateOfBirth.error'
export const ERR_DOB_TOO_YOUNG = 'customers.dateOfBirth.tooYoung'
export const ERR_EMAIL_INUSE = 'customers.email.alreadyExists'
export const ERR_EMAIL_INVALID = 'customers.email.invalid'
export const ERR_LMS_EMAIL_INVALID = 'customers.email.missingOrInvalidFormat'
export const ERR_FIRSTNAME_INVALID = 'customers.firstName.invalid'
export const ERR_LASTNAME_INVALID = 'customers.lastName.invalid'
export const ERR_SALUTATION_ERROR = 'customers.salutation.error'
export const ERR_PASSWORD_TOOSHORT = 'customers.password.tooShort'
export const ERR_TOS_NOT_ACCEPTED = 'customers.tosAccepted.notAccepted'

export const MAX_NAME_LENGTH = 25
export const MIN_AGE = 18
export const MIN_COMPANY_NAME_LENGTH = 2
export const MIN_PASSWORD_LENGTH = 6

export const errorMessagesFieldMap = {
  [ERR_EMAIL_INUSE]: EMAIL_FIELD,
  [ERR_EMAIL_INVALID]: EMAIL_FIELD,
  [ERR_LMS_EMAIL_INVALID]: EMAIL_FIELD,
  [ERR_FIRSTNAME_INVALID]: FIRSTNAME_FIELD,
  [ERR_LASTNAME_INVALID]: LASTNAME_FIELD,
  [ERR_PASSWORD_TOOSHORT]: PASSWORD_FIELD,
}

export function translateErrors(mountPoints) {
  return {
    [GENERAL_ERROR]: <Trans id="general.error" />,
    [ERROR_BADINPUT]: <Trans id="register.error.badinput" />,
    [ERROR_UNAVAILABLE]: <Trans id="register.error.unavailable" />,
    [ERROR_AUTH_SERVICE]: (
      <Trans
        id="register.error.cas.unavailable"
        components={{
          /* eslint-disable-next-line jsx-a11y/anchor-has-content */
          0: <a href={mountPoints.getForgotPassword()} />,
        }}
      />
    ),
    [ERR_DOB_INVALID]: <Trans id={ERR_DOB_INVALID} />,
    [ERR_DOB_TOO_YOUNG]: (
      <Trans
        id={'login.createAccount.dateSelection.minAge'}
        values={{ minAge: MIN_AGE }}
      />
    ),
    [ERR_EMAIL_INUSE]: <Trans id={'register.error.email.inUse'} />,
    [ERR_EMAIL_INVALID]: <Trans id={'register.error.email.invalid'} />,
    [ERR_LMS_EMAIL_INVALID]: <Trans id={'register.error.email.invalid'} />,
    [ERR_FIRSTNAME_INVALID]: <Trans id={'error.firstName.invalid'} />,
    [ERR_LASTNAME_INVALID]: <Trans id={'error.lastName.invalid'} />,
    [ERR_PASSWORD_TOOSHORT]: <Trans id={'error.password.tooShort'} />,
    [ERR_TOS_NOT_ACCEPTED]: <Trans id={'error.tos.notAccepted'} />,
    [ERR_SALUTATION_ERROR]: <Trans id={'error.salutation.notChosen'} />,
  }
}
